import { faMessage, faPaperPlane, faRefresh, faRotateRight, faSpinner, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react"
import { Button, Card, Form } from "react-bootstrap"
import "./chatBot.scss"
import useConversation from "mutationHooks/chatMutationHooks/useConversation";
import { BotMessage, ChatMessage, UserMessage } from "types/chat";
import Message from "./Message";
import { send } from "process";

const ChatBot = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [messages, setMessages] = useState<ChatMessage[]>([]);
    const [input, setInput] = useState("");
    const sendMessage = useConversation()

    const handleSend = async () => {
        if (!input.trim()) return;
        const userMessage: UserMessage = { sender: "user", text: input };
        setMessages((prev) => [...prev, userMessage]);
        sendMessage.mutate(input, {
            onSuccess: (res) => {
                const botMessage: BotMessage = { sender: "bot", results: res.results };
                setMessages((prev) => [...prev, botMessage]);
            }
        });
        setInput("");
    }

    return (
        <>
            <Button
                variant="primary"
                onClick={() => setIsOpen(!isOpen)}
                className="chat-btn rounded-circle p-3"
                title="AI Assistant"
            >
                <FontAwesomeIcon icon={faMessage} size="1x" className="mt-1" />

            </Button>

            {isOpen && (
                <Card
                    className="chatbot-card"
                >
                    <Card.Header>
                        <div className="d-flex justify-content-between align-items-center">
                            <span><b>Ask AI</b></span>
                            <div>
                                <Button variant="muted" size="sm" onClick={() => setMessages([])}>
                                    <FontAwesomeIcon icon={faRotateRight} />
                                </Button>
                                <Button variant="muted" size="sm" onClick={() => setIsOpen(false)}>
                                    <FontAwesomeIcon icon={faXmark} />
                                </Button>
                            </div>
                        </div>
                    </Card.Header>
                    <Card.Body style={{ flex: 1, overflowY: "auto" }}>
                        {messages.length > 0 ? (
                            <>
                                {
                                    messages.map((msg, idx) => (
                                        <Message key={idx} message={msg} />
                                    ))
                                }
                                {
                                    sendMessage.isLoading && (
                                        <div style={{ textAlign: "left", margin: "5px 0" }}>
                                            <span className="bot-message">
                                                ...
                                            </span>
                                        </div>
                                    )
                                }
                            </>
                        ) : (<div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
                            <h4 className="text-secondary">Start a new conversation by typing below.</h4>
                        </div>)}
                    </Card.Body>
                    <Card.Footer className="d-flex">
                        <Form.Control
                            type="text"
                            value={input}
                            size="sm"
                            placeholder="Type a message..."
                            onChange={(e) => setInput(e.target.value)}
                            onKeyDown={(e) => e.key === "Enter" && handleSend()}
                        />
                        <Button variant="outline-primary" onClick={handleSend} className="ms-2">
                            <FontAwesomeIcon icon={faPaperPlane} />
                        </Button>
                    </Card.Footer>
                </Card>
            )}
        </>
    )
}

export default ChatBot